import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ReleaseMode } from 'shell/models/release-mode';
import { DateTime } from 'luxon';
import { ReleaseModeForm } from '../form';

export const transformReleaseMode = (
  response: AxiosResponse<HttpResponse<ReleaseMode>>
): ReleaseModeForm => {
  const data: ReleaseMode = response.data.payload || {};

  const result: ReleaseModeForm = {
    code: data.key?.codiceModalitaRilascio || '',
    descriptionRelease: data?.descrizione,
    descriptionPrint: data?.descrizioneModalitaStampa,
    register: data?.tipoRegistro || '',
    exemption: data?.codiceEsenzioneAnpr,
    use: data.codiceUsoModalita,
    dateFrom: data?.dataInizioValidita ? DateTime.fromISO(data?.dataInizioValidita) : null,
    dateTo: data?.dataFineValidita ? DateTime.fromISO(data?.dataFineValidita) : null,
    typePayment: {
      stamp: data?.importoImpostaBollo,
      secretariat: data?.importoDirittiSegreteria,
      maritalStatus: data?.importoDirittiStatoCivile,
      fixed: data?.importoDirittiFissi,
      expenses: data?.importoSpese,
      stampCode: data?.codiceImpImpostaBollo,
      maritalStatusCode: data?.codiceImpDirittiStatoCivile,
      secretariatCode: data?.codiceImpDirittiSegreteria,
      fixedCode: data?.codiceImpDirittiFissi,
      expensesCode: data?.codiceImpSpese,
    },
  };

  return result;
};
